import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, useTheme } from "@mui/material";
import CartContextProvider from "@/context/CartContext";
import AppRoutes from "./components/AppRoutes";
var App = function () {
    var theme = useTheme();
    return (React.createElement(CartContextProvider, null,
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(Router, null,
                React.createElement(AppRoutes, null)))));
};
export default App;
